const documentConstants = {
  GET_DOCTITLE: 'GET_DOCTITLE',
  SET_DOCTITLE: 'SET_DOCTITLE',
  SET_ERR: 'SET_ERR',
  GET_DOCFILE: 'GET_DOCFILE',
  SET_DOCFILE: 'SET_DOCFILE',
  SET_ACTIVE_NOTIFICATION: 'SET_ACTIVE_NOTIFICATION',
  APPEND_ACTIVE_NOTIFICATION: 'APPEND_ACTIVE_NOTIFICATION',
  SET_DOC_LOADING: 'SET_DOC_LOADING',
};

export default documentConstants;
